import React, { useState } from 'react';

interface Props {
  dia: string;
  onClose: () => void;
  onGuardar: (ejercicio: any) => void;
}

export default function EjercicioModal({ dia, onClose, onGuardar }: Props) {
  const [nombre, setNombre] = useState('');
  const [series, setSeries] = useState('');
  const [repeticiones, setRepeticiones] = useState('');
  const [descanso, setDescanso] = useState('');

  const handleGuardar = () => {
    onGuardar({
      dia,
      nombre,
      series,
      repeticiones,
      descanso,
    });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center'
    }}>
      <div style={{ background: 'white', padding: 24, borderRadius: 8, width: 300 }}>
        <h3>Agregar ejercicio - {dia}</h3>
        <input placeholder="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} />
        <input placeholder="Series" value={series} onChange={e => setSeries(e.target.value)} />
        <input placeholder="Repeticiones o tiempo" value={repeticiones} onChange={e => setRepeticiones(e.target.value)} />
        <input placeholder="Descanso entre series" value={descanso} onChange={e => setDescanso(e.target.value)} />
        <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between' }}>
          <button onClick={onClose}>Cancelar</button>
          <button onClick={handleGuardar}>Guardar</button>
        </div>
      </div>
    </div>
  );
}
